import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.418 5c-1.012 0-1.833.82-1.833 1.833V21.5a1.833 1.833 0 0 0 3.667 0V6.833A1.834 1.834 0 0 0 9.418 5m9.167 0c-1.012 0-1.833.82-1.833 1.833V21.5a1.833 1.833 0 0 0 3.666 0V6.833c0-1.012-.82-1.833-1.833-1.833"
    }, null, -1)
  ]))]))
}
export default { render: render }